import { useHelloQuery } from '@/api/queries'
import { useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import { InputNumber } from 'primereact/inputnumber'
import { ProgressBar } from 'primereact/progressbar'
import ResultWithProgress from '@/components/ResultWithProgress'

function ApiIntegration() {
  const [shouldError, setShouldError] = useState(false)
  const [waitTime, setWaitTime] = useState(0)

  // TanStack Queryを使用してAPIデータを取得
  const {
    data: helloData,
    isLoading,
    isObserving,
    isError,
    error,
    refetch,
    lastLog,
    logs,
    progress,
  } = useHelloQuery({
    shouldError: shouldError,
    waitTime: waitTime,
  },{
    enabled: true,
    retry: false,
  })

  const handleRefetch = () => {
    refetch()
  }

  const toggleError = () => {
    setShouldError(!shouldError)
  }

  const handleWaitTimeChange = (value: number | null) => {
    setWaitTime(value || 0)
  }

  return (
    <div className="flex flex-column align-items-center">
      <h2 className="text-primary text-xl mb-3">API連携</h2>
      <p className="text-lg mb-4">
        バックエンドとの連携テスト
      </p>

      <div className="flex gap-3 mb-4">
        <Button
          label="再取得"
          icon="pi pi-refresh"
          onClick={handleRefetch}
          disabled={isLoading}
        />
        <Button
          label={shouldError ? "エラーモード: ON" : "エラーモード: OFF"}
          icon={shouldError ? "pi pi-exclamation-triangle" : "pi pi-check"}
          severity={shouldError ? "danger" : "info"}
          onClick={toggleError}
        />
        <span className="p-float-label">
          <InputNumber
            id="waitTime"
            value={waitTime}
            onValueChange={(e) => handleWaitTimeChange(e.value ?? 0)}
            min={0}
            max={60_000}
            suffix=" msec"
          />
          <label htmlFor="waitTime">待機時間</label>
        </span>
      </div>

      <div className="w-full max-w-30rem mt-4">
        <ResultWithProgress
          isObserving={isObserving}
          progress={progress}
          lastLog={lastLog}
          logs={logs}
          isError={isError}
          error={error}
        >
          <div className="p-3 surface-card border-round shadow-2">
            <p className="font-semibold text-center">バックエンドからのメッセージ:</p>
            <p className="text-blue-600 text-center text-xl">{helloData?.message}</p>
            <p className="text-center">ステータス: {helloData?.status}</p>
          </div>
        </ResultWithProgress>
      </div>
    </div>
  )
}

export default ApiIntegration
